/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_Start_Tc_HelpInputs */

const en_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When inserting a new event, the start timecode will automatically be set based on the video timecode.`)
};

const fr_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lors de l'insertion d'un nouvel événement, le code temporel de début est défini automatiquement à partir du timecode vidéo.`)
};

const de_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Einfügen eines neuen Ereignisses wird der Startzeitcode automatisch anhand des Videozeitcodes festgelegt.`)
};

const it_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando si inserisce un nuovo evento, il timecode di inizio verrà impostato automaticamente in base al timecode video.`)
};

const ru_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При добавлении нового события начальный таймкод будет автоматически установлен на основе таймкода видео.`)
};

const es_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al insertar un nuevo evento, el código de tiempo de inicio se establecerá automáticamente en función del código de tiempo del vídeo.`)
};

const zh_cn2_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入新事件时，开始时间码将根据视频时间码自动设置。`)
};

const ja_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントを挿入すると、ビデオのタイムコードに基づいて開始タイムコードが自動的に設定されます。`)
};

const hi_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब कोई नया इवेंट डाला जाता है, तो वीडियो टाइमकोड के आधार पर स्टार्ट टाइमकोड अपने आप सेट हो जाएगा।`)
};

const pt_pt2_options_editor_insert_start_tc_help = /** @type {(inputs: Options_Editor_Insert_Start_Tc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao inserir um novo evento, o código de tempo inicial será definido automaticamente com base no código de tempo do vídeo.`)
};

/**
* | output |
* | --- |
* | "When inserting a new event, the start timecode will automatically be set based on the video timecode." |
*
* @param {Options_Editor_Insert_Start_Tc_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_start_tc_help = /** @type {((inputs?: Options_Editor_Insert_Start_Tc_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_Start_Tc_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_insert_start_tc_help(inputs)
	if (locale === "de") return de_options_editor_insert_start_tc_help(inputs)
	if (locale === "it") return it_options_editor_insert_start_tc_help(inputs)
	if (locale === "ru") return ru_options_editor_insert_start_tc_help(inputs)
	if (locale === "es") return es_options_editor_insert_start_tc_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_insert_start_tc_help(inputs)
	if (locale === "ja") return ja_options_editor_insert_start_tc_help(inputs)
	if (locale === "hi") return hi_options_editor_insert_start_tc_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_insert_start_tc_help(inputs)
	return en_options_editor_insert_start_tc_help(inputs)
});